import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import constClass from '../../Constants/Constants';
import { Link } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import moment from 'moment';
import { useReactToPrint } from "react-to-print";
import { CSVLink } from "react-csv";
import Select from 'react-select';
import { useParams, generatePath } from 'react-router';
// import Common from '../Common/common';
import "react-datepicker/dist/react-datepicker.css"
import InfiniteScroll from "react-infinite-scroller";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ja from 'date-fns/locale/ja';
registerLocale('ja', ja);
const pageCount = 100;

const RankUpBonusDownload = (props) => {
  const { siteId, mallId } = useParams();
  const { setting } = props;
  const [benefitGrantData, setBenefitGrantData] = useState(null);
  const [sortOrder, setSortOrder] = useState([]); // ソート順指定
  const [searchMallId, setSearchMallId] = useState(null);
  const [benefitId, setBenefitId] = useState(null);
  const [searchYearGrant, setSearchYearGrant] = useState(new Date(2025, 0, 1));
  const [searchFlag, setSearchFlag] = useState(true);
  // const componentRef = useRef();
  const [csvData, setCsvData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();
  const [page, setPage] = useState(0);
  const [mallMaster, setMallMaster] = useState(null);
  const [benefitMaster, setBenefitMaster] = useState(null);
  const contentRef = useRef();
  const reactToPrintFn = useReactToPrint({
    content: () => contentRef.current
  });

  const createCsvData = useCallback((data, mallMaster, benefitMaster) => {
    const list = [];
    const head = [
      { label: '会員ID', key: 'customer_id' },
      { label: '施設', key: 'mall_name' },
      { label: '特典', key: 'benefit_title' },
      { label: '利用日時', key: 'use_date' },
      { label: '郵便番号', key: 'postal_code' },
      { label: '電話番号', key: 'phone_number' },
      { label: 'メールアドレス', key: 'email' },
      { label: '住所', key: 'address' },
      { label: '氏名', key: 'name' },
      { label: 'ステータス', key: 'status' },
    ];
    data.forEach(r => {
      var benefit = {
        ...r,
        mall_name: getMall(r, mallMaster).mall_name,
        benefit_title: getBenefit(r, benefitMaster).benefit_title,
        use_date: r.use_date ? moment(r.use_date).format("YYYY/MM/DD HH:mm:ss") : '',
        status: r.status ? constClass.BENEFIT_STATUS_NAME[r.status] : '',
      };
      list.push(benefit);
    });

    setCsvData({ header: head, list: list });
  }, []);

  const accessLog = async () => {
    const jwt = localStorage.getItem('jwt');
    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefitgrant/printcsv/rankupbonusdownload/accesslog`, {}, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    });
  };

  const refreshCustomerBenefit = useCallback(async () => {
    if (setting) {
      // useCallback対応のため検索ボタンを押したときのみ実行
      if (searchFlag) {
        const jwt = localStorage.getItem('jwt');

        const mall = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mall/${siteId}`, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        })).data;
        setMallMaster(mall);

        const benefit = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/benefit/${siteId}`, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        })).data;
        setBenefitMaster(benefit);

        const params = {
          site_id: siteId
        };
        if (searchMallId) {
          params.mall_id = searchMallId.value;
        }
        if (benefitId) {
          params.benefit_id = benefitId.value;
        }

        // 特典データ
        const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefitgrant/search/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`,
          }
        })).data;
        if (searchYearGrant) {
          setBenefitGrantData(data.filter(d => moment(d.ins_date).format("YYYY") === moment(searchYearGrant).format("YYYY")));
        } else {
          setBenefitGrantData(data);
        }
        createCsvData(data, mall, benefit);
      }
      setSearchFlag(false);
    }
  }, [searchFlag, createCsvData, setting, siteId, benefitId, searchMallId, searchYearGrant]);

  const handleHeaderClick = (column) => {
    var _sortOrder = sortOrder.slice();
    if (_sortOrder.map(s => s.column).includes(column)) { // 既に登録済み
      if (_sortOrder[0].column !== column) { // 先頭ではない
        _sortOrder.splice(_sortOrder.findIndex(s => s.column === column), 1); //削除
        _sortOrder.unshift({ column, order: 'ASC' }); // 追加
      } else { //先頭 並び順変更
        _sortOrder[0].order = _sortOrder[0].order === 'ASC' ? 'DESC' : 'ASC';
      }
    } else { //未登録
      _sortOrder.unshift({ column, order: 'ASC' }); // 追加
    }
    if (_sortOrder.length > 3) { //ソート順は3件まで
      _sortOrder.pop();
    }
    setSortOrder(_sortOrder);
  }

  const sortData = (a, b) => {
    if (sortOrder.length <= 0) { // 初期値はお客様ID
      return Number(a.customer_id) - Number(b.customer_id);
    }
    for (var i = 0; i < sortOrder.length; i++) {
      const item = sortOrder[i];
      // const detail = item.detail.find(() => true);
      // 既存のソート処理
      if (item.input_type === 'radio') {
        const aData = item.detail.find(d => d.entry_data === a[item.column]) ? item.detail.find(d => d.entry_data === a[item.column]).entry_seq : 0;
        const bData = item.detail.find(d => d.entry_data === b[item.column]) ? item.detail.find(d => d.entry_data === b[item.column]).entry_seq : 0;
        if (item.order === 'ASC') {
          if (aData < bData) return -1;
          if (aData > bData) return 1;
        } else {
          if (bData < aData) return -1;
          if (bData > aData) return 1;
        }
      } else if (item.input_type === 'id') {
        if (item.order === 'ASC') {
          if (Number(a[item.column]) < Number(b[item.column])) return -1;
          if (Number(a[item.column]) > Number(b[item.column])) return 1;
        } else {
          if (Number(b[item.column]) < Number(a[item.column])) return -1;
          if (Number(b[item.column]) > Number(a[item.column])) return 1;
        }
      } else if (['date-y', 'date-m', 'date-d'].includes(item.input_type)) {
        const start = item.input_type === 'date-y' ? 0 : item.input_type === 'date-m' ? 4 : 6;
        const end = item.input_type === 'date-y' ? 4 : item.input_type === 'date-m' ? 6 : 8;
        const aData = Number(a[item.entry_type] ? a[item.entry_type].slice(start, end) : 0);
        const bData = Number(b[item.entry_type] ? b[item.entry_type].slice(start, end) : 0);
        if (item.order === 'ASC') {
          if (aData < bData) return -1;
          if (aData > bData) return 1;
        } else {
          if (bData < aData) return -1;
          if (bData > aData) return 1;
        }
      } else {
        if (item.order === 'ASC') {
          if (a[item.column] < b[item.column]) return -1;
          if (a[item.column] > b[item.column]) return 1;
        } else {
          if (b[item.column] < a[item.column]) return -1;
          if (b[item.column] > a[item.column]) return 1;
        }
      }
    }
    return 0;
  }

  /* 送付処理 */
  const handleInfoDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!window.confirm(`会員ID[${data.customer_id}]施設[${getMall(data, mallMaster).mall_name}]特典[${getBenefit(data, benefitMaster).benefit_title}]の情報を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      customer_id: data.customer_id,
      benefit_id: data.benefit_id,
      issue_count: data.issue_count,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefitgrant/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
      if (res && res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      }
      else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
      }
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      setSearchFlag(true);
      await refreshCustomerBenefit();
      setLockData(false);
    }
  }

  /* 送付処理 */
  const handleSentClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`会員ID[${data.customer_id}]特典[${getBenefit(data, benefitMaster).benefit_title}]のステータスを送付済みとします。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      benefit_id: data.benefit_id,
      issue_count: data.issue_count,
      status: constClass.BENEFIT_STATUS.SENT,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefitgrant/status/${data.customer_id}`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
      if (res && res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      }
      else {
        addToast('更新しました。', { appearance: 'success', autoDismiss: true });
      }
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      setSearchFlag(true);
      await refreshCustomerBenefit();
      setLockData(false);
    }
  }

  const renderSortTh = (column) =>
    <th className="text-center align-middle like-button p-0 m-0" onClick={() => handleHeaderClick(column)} key={column}>
      {sortOrder.filter(s => s.column === column).map((item, idx, self) =>
        <span key={idx}>{item.order === 'ASC' ? '▲' : '▼'}{sortOrder.findIndex(s => s.column === column) + 1}</span>
      )}
    </th>

  const renderSentButton = (data) => {
    return (
      <button
        className={`btn btn-secondary mx-1`}
        disabled={lockData}
        onClick={() => handleSentClick(data)}
      >
        送付
      </button>
    )
  }

  const renderInfoDeleteButton = (data) => {
    return (
      <button
        className={`btn btn-secondary mx-1`}
        disabled={lockData}
        onClick={() => handleInfoDeleteClick(data)}
      >
        情報削除
      </button>
    )
  }

  const getMall = (data, mallMaster) => {
    return data.mall_id && mallMaster && mallMaster.find(m => m.mall_id === data.mall_id) ? mallMaster.find(m => m.mall_id === data.mall_id) : {}
  }

  const getBenefit = (data, benefitMaster) => {
    return data.benefit_id && benefitMaster && benefitMaster.find(b => b.benefit_id === data.benefit_id) ? benefitMaster.find(b => b.benefit_id === data.benefit_id) : {}
  }

  useEffect(() => {
    refreshCustomerBenefit();
  }, [refreshCustomerBenefit]);

  return (
    <div className="container">
      <div className="row mx-0 my-3 px-1-env">
        <div className="col-2 px-0 mx-0">
          <div className="row px-0 mx-0">
            <div className="col-auto pr-0 pl-1 text-center align-self-center">
              <span>施設</span>
            </div>
            <div className="col text-center">
              <Select
                styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
                options={mallMaster ? mallMaster.map(m => ({ value: m.mall_id, label: `${m.mall_name}` })) : []}
                isClearable={true}
                closeMenuOnSelect={true}
                value={searchMallId || null}
                onChange={(value) => setSearchMallId(value)} />
            </div>
          </div>
        </div>
        <div className="col-3 px-0 mx-0">
          <div className="row px-0 mx-0">
            <div className="col-auto pr-0 pl-1 text-center align-self-center">
              <span>特典</span>
            </div>
            <div className="col text-center">
              <Select
                styles={{ container: (base) => ({ ...base, zIndex: 600 }) }}
                options={benefitMaster ? benefitMaster.map(b => ({ value: b.benefit_id, label: `${b.benefit_title}` })) : []}
                isClearable={true}
                closeMenuOnSelect={true}
                value={benefitId || {}}
                onChange={(value) => setBenefitId(value)} />
            </div>
          </div>
        </div>
        <div className="col-3 px-0 mx-0">
          <div className="row px-0 mx-0">
            <div className="col-auto pr-0 pl-1 text-center align-self-center">
              <span>付与年</span>
            </div>
            <div className="col text-center">
              <DatePicker className="custom-select text-left"
                locale="ja" dateFormat="yyyy" monthsShown="1" id={'searchYearGrant'} name={'searchYearGrant'}
                popperPlacement='bottom'
                selected={searchYearGrant}
                onChange={(value) => setSearchYearGrant(value)}
                placeholderText="- 選択 -"
                autoComplete='off'
                showYearPicker
                yearItemNumber={15}
                minDate={new Date(2024, 0, 1)}
                maxDate={new Date(new Date().getFullYear(), 11, 31)}
              />
            </div>
          </div>
        </div>
        <div className="text-center">
          <button type="button"
            className={`btn btn-primary mx-1 w-100 text-nowrap`}
            onClick={() => setSearchFlag(true)}>
            検索</button>
        </div>
      </div>
      {benefitGrantData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {benefitGrantData !== null && (
        <div ref={contentRef} className="print-list">
          <div className="row mb-0 p-0 ">
            <div className="col-10 pl-0 text-left align-self-end">
              <div className="row mr-0">
                <div className="col-2 pr-2 align-self-center">
                  {benefitGrantData[0] &&
                    // <useReactToPrint
                    //   trigger={() => (
                    //     <button type="button" className="btn btn-primary print-none px-0 mb-1 w-100" onClick={() => reactToPrintFn()}>
                    //       一覧表印刷
                    //     </button>
                    //   )}
                    //   content={() => componentRef.current}
                    //   pageStyle={""}
                    //   onBeforeGetContent={() => accessLog()}
                    // />
                  <button
                    type="button"
                    className="btn btn-primary print-none px-0 mb-1 w-100"
                    onClick={() => {reactToPrintFn(); accessLog();}}
                  >
                    一覧表印刷
                  </button>                  
                  }
                </div>
                <div className="col-2 px-2 align-self-center">
                  {benefitGrantData[0] && csvData &&
                    <CSVLink className="btn btn-primary print-none mb-1 px-0 w-100" data={csvData.list.sort((a, b) => sortData(a, b))} headers={csvData.header} filename={"特典利用状況一覧.csv"} onClick={() => accessLog()}>
                      一覧表CSV出力
                    </CSVLink>
                  }
                </div>
              </div>
            </div>
            <div className="col-2 px-2 align-self-center text-right border h-100">
              <div className="row">
                <div className="col-auto py-1 px-2 bg-lightwhite h-100">一覧表件数</div>
                <div className="col py-1">{benefitGrantData.length.toLocaleString()}</div>
              </div>
            </div>
          </div>
          <div className="row mb-3 p-0">
            <div className="col-12 p-0">
              <InfiniteScroll
                loadMore={(p) => setPage(Number(p) * pageCount)}    //項目を読み込む際に処理するコールバック関数 
                hasMore={(benefitGrantData.length > page)}         //読み込みを行うかどうかの判定
                loader={<div key={-1}>{benefitGrantData.length}件中 {page + pageCount}件まで表示中（スクロールで読み込み）</div>}       //読み込み最中に表示する項目
              >
                <table className="table table-bordered table-striped" height="1">
                  <thead className={`table-info`}>
                    <tr>
                      <th className="text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('customer_id', [])}>
                        会員ID
                      </th>
                      <th className="text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('mall_id', [])}>
                        施設
                      </th>
                      <th className="text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('benefit_title', [])}>
                        特典
                      </th>
                      <th className="text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('use_date', [])}>
                        利用日時
                      </th>
                      <th className="text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('postal_code', [])}>
                        郵便番号
                      </th>
                      <th className="text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('address', [])}>
                        住所
                      </th>
                      <th className="text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('name', [])}>
                        氏名
                      </th>
                      <th className="text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('phone_number', [])}>
                        電話番号
                      </th>
                      <th className="text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('email', [])}>
                        メールアドレス
                      </th>
                      <th className="text-center align-middle text-nowrap like-button" onClick={() => handleHeaderClick('status', [])}>
                        ステータス
                      </th>
                      <th className="text-center align-middle print-none">
                        処理
                      </th>
                    </tr>
                    <tr className="print-none">
                      {renderSortTh('customer_id')}
                      {renderSortTh('mall_id')}
                      {renderSortTh('benefit_title')}
                      {renderSortTh('use_date')}
                      {renderSortTh('postal_code')}
                      {renderSortTh('address')}
                      {renderSortTh('name')}
                      {renderSortTh('phone_number')}
                      {renderSortTh('email')}
                      {renderSortTh('status')}
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {benefitGrantData.sort((a, b) => sortData(a, b)).map((data, idx) => (
                      <tr key={`${data.benefit_id}_${data.customer_id}_${data.issue_count}`}>
                        <td className="text-center align-middle p-1">
                          <Link to={`${generatePath(`${props.match.path}`, { siteId, mallId })}customer/${data.customer_id}`}>{data.customer_id}</Link>
                        </td>
                        <td className="text-center align-middle p-1">
                          {getMall(data, mallMaster).mall_name}
                        </td>
                        <td className="text-center align-middle p-1">
                          {getBenefit(data, benefitMaster).benefit_title}
                        </td>
                        <td className="text-center align-middle p-1">
                          {data.use_date ? moment(data.use_date).format("YYYY/MM/DD HH:mm:ss") : ''}
                        </td>
                        <td className="text-center align-middle p-1">
                          {data.postal_code}
                        </td>
                        <td className="text-center align-middle p-1">
                          {data.address}
                        </td>
                        <td className="text-center align-middle p-1">
                          {data.name}
                        </td>
                        <td className="text-center align-middle p-1">
                          {data.phone_number}
                        </td>
                        <td className="text-center align-middle p-1">
                          {data.email}
                        </td>
                        <td className="text-center align-middle p-1">
                          {data.status ? constClass.BENEFIT_STATUS_NAME[data.status] : ''}
                        </td>
                        <td className="text-center text-nowrap align-middle p-1 print-none">
                          {constClass.BENEFIT_STATUS_NAME.NOTSENT === constClass.BENEFIT_STATUS_NAME[data.status] && renderSentButton(data)}
                          {renderInfoDeleteButton(data)}
                        </td>
                      </tr>
                    ))
                    }
                  </tbody>
                </table>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default RankUpBonusDownload;